import type { CurvaDocument } from "@/document/model/document";
import type { ComponentNode } from "@/document/model/nodes";
import { componentVariants } from "@/document/operations/componentSystem";
import { exportSceneNodeThumbnailDataUrl } from "./pngExporter";

export async function renderComponentThumbnailDataUrl(
  document: CurvaDocument,
  component: ComponentNode,
  boxSize = 80,
): Promise<string> {
  const variant = componentVariants(component)[0];
  if (!variant) {
    return "";
  }

  return exportSceneNodeThumbnailDataUrl(document, variant, boxSize);
}
